/**
 * Minimal toast notifications. One at a time.
 */

let timeoutId: number | null = null;

export function showToast(message: string, durationMs = 2400): void {
  const el = document.getElementById("toast");
  if (!el) return;
  el.textContent = message;
  el.classList.remove("hidden");
  if (timeoutId !== null) {
    clearTimeout(timeoutId);
  }
  timeoutId = window.setTimeout(() => {
    el.classList.add("hidden");
    timeoutId = null;
  }, durationMs);
}
